import { Flex, Text } from "@fluentui/react-northstar";
import { TeamsSubscriptionPlans } from "@teams/types";
import { UserDTO } from "@teams/types/api";
import React from "react";

import { PlanItem } from "./PlanItem";

type Props = {
  user: UserDTO;
  isTrialMode?: boolean;
  onPlanSelected: () => void;
  onTrialRequested: (plan: TeamsSubscriptionPlans) => Promise<string | undefined>;
};

export const AgilePollyPlanSelection: React.FC<Props> = ({
  user,
  onPlanSelected,
  onTrialRequested,
  isTrialMode,
}) => {
  const { featureFlags } = user;

  return (
    <Flex hAlign="center" column>
      <PlanItem
        plan="agile-standup"
        background="https://www.polly.ai/hubfs/agile_bg-3.svg"
        description={
          isTrialMode ? (
            <>
              Take AgilePolly for a test drive with a free {featureFlags.agileStandupTrialLength}{" "}
              day trial.
              <br />
              When your trial ends, you'll be prompted to purchase a subscription to continue the
              use of AgilePolly.
            </>
          ) : undefined
        }
        price="$3/active user/Month"
        priceTooltip="An active user is defined as anyone that responds to your standups"
        onPlanSelected={(plan, isTrial) => {
          if (isTrial) {
            return onTrialRequested(plan);
          } else {
            onPlanSelected();
            return Promise.resolve(undefined);
          }
        }}
        isTrialMode={isTrialMode}
        trialDays={featureFlags.agileStandupTrialLength}
        billingFrequency="monthly"
        primaryColor="#A0A4F8"
        user={user}
        features={[
          ["Standups", true],
          ["Exports", true],
          ["Reminders", true],
          ["Premium Support", true],
        ]}
      />

      <Text
        className="msteams-plan-selection__learn-more"
        align="center"
        weight="bold"
        content={
          <>
            Want more information on plans and features?{" "}
            <a
              href="https://www.polly.ai/agile-polly-for-microsoft-teams"
              target="_blank"
              rel="noopener noreferrer"
            >
              Learn more here
            </a>
          </>
        }
        size="medium"
      />
    </Flex>
  );
};
